<script>
import App from '@/pages/layouts/app.vue';
import Sortable from 'sortablejs';
import Card from "@/pages/components/card.vue";

const requireComponent = require.context("@/pages/widgets/", false, /\w+\.(vue|js)$/);
let components = {App, Card};
for (let fileName of requireComponent.keys()) {
  let name = fileName.split("/").pop().split(".")[0];
  components[name] = requireComponent(fileName).default;
}

export default {
  components: components,
  data() {
    return {
      'widgets': {},
      'activeWidgets': {},
    }
  },
  mounted() {
    this.getWidgets();
    new Sortable(this.$refs.sortable, {
      swapThreshold: 1,
      animation: 150,
      handle: '.sortable-handle',
      onEnd: (event) => {
        let $widget = $(event.item);

        $.ajax({
          method: 'PUT',
          url: route('widgets.update'),
          data: {
            id: $widget.data('widget-id'),
            prio: event.newIndex,
          }
        });
      }
    })
  },

  methods: {
    getWidgets() {
      $.ajax({
        url: route('widgets'),
        success: (response) => {
          this.widgets = response.widgets;
          this.activeWidgets = response.active_widgets;
        }
      });
    },

    addWidget(event) {
      let $button = $(event.currentTarget);
      let id = $button.data('widget');

      $.ajax({
        url: route('widgets.store'),
        method: 'POST',
        data: {
          id: id,
        },
        success: (response) => {
          this.getWidgets();
        }
      });
    },

    removeWidget(event) {
      let $button = $(event.currentTarget);
      let id = $button.data('widget');

      $.ajax({
        url: route('widgets.delete'),
        method: 'DELETE',
        data: {
          id: id,
        },
        success: (response) => {
          this.getWidgets();
        }
      });
    },
  }
}
</script>

<template>
  <App title="Dashboard">
    <div ref="sortable" class="dashboard-grid mb-4">
      <Card v-for="widget in activeWidgets" :key="widget.id" :data-widget-id="widget.id">
        <div class="sortable-handle d-flex justify-content-between align-items-center mb-3 border-bottom mt-ncard mx-ncard p-card">
          <h2 class="card-title m-0"><i class="bi bi-arrows-move me-2"></i> {{ widget.name }}</h2>
          <button @click.prevent="removeWidget" :data-widget="widget.id" class="btn btn-sm btn-danger">
            <i class="bi bi-trash3-fill"></i>
          </button>
        </div>
        <component :is="widget.view_path"></component>
      </Card>
    </div>

    <template #topButtons>
      <div class="dropdown" v-if="widgets.length > 0">
        <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-gear"></i>
          Widgets
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li v-for="widget in widgets" :key="widget.id">
            <button class="dropdown-item" @click.prevent="addWidget" :data-widget="widget.id">{{ widget.name }}</button>
          </li>
        </ul>
      </div>
    </template>
  </App>
</template>